import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { AbstractPage } from '../AbstractPage';

@Component({
    selector: 'app-notifying',
    templateUrl: './notifying.page.html',
    styleUrls: ['./notifying.page.scss'],
    standalone: false
})
export class NotifyingPage extends AbstractPage implements OnInit {
  type: string;
  image: string;
  title: string;
  message: string;
  textOk = 'Ok';
  textCancel = 'Cancel';
  buttons = '1';
  popoverCtrl = null;
  constructor(
    public navCtrl: NavController,
    public router: Router,
    public route: ActivatedRoute,
    public navParams: NavParams,
    public modalCtrl: ModalController,
  ) {
    super(navCtrl, router);
    // sostituita l'implementazione di questa finestra utilizzata come modale centratautilizzando un popover
    this.type = navParams.get('type');
    this.image = navParams.get('image');
    this.title = navParams.get('title');
    this.message = navParams.get('message');
    this.popoverCtrl = navParams.get('popoverController');
    if (navParams.get('textOk') && navParams.get('textOk') !== '') {
      this.textOk = navParams.get('textOk');
    }
    if (navParams.get('textCancel') && navParams.get('textCancel') !== '') {
      this.textCancel = navParams.get('textCancel');
    }
    if (navParams.get('buttons') && navParams.get('buttons') !== '') {
      this.buttons = navParams.get('buttons');
    }
  }


  ngOnInit() {
    console.log('ngOnInit NotifyingPage');
  }

  async isConfirm() {
    let data = {}; // param for yes
    if (this.type === 'success') {
      // console.log( 'isConfirm in notifying' );
       data = { res: 'yes' }; // param for yes
    }
    await this.popoverCtrl.dismiss(data);
  }
  async isCancel() {
    // console.log( 'isCancel in notifying' );
    await this.popoverCtrl.dismiss();
  }
}
